import axios from 'axios'
const CancleToken = axios.CancelToken
/** 监控中心leaflet版本，地图功能部分
 */
const leafLetCtl = {
  /** 获取设备定位详细信息
   * @param _this {object} 页面指针
   * * @param url {string} 接口地址
   * * * @param devIdList {Array} 设备ID
   */
  getLocationByDevId(_this, url, devIdList) {
    _this.$axios({
      method: 'post',
      url: url,
      data: {
        devIdList: devIdList
      },
      cancelToken: new CancleToken(function (c) {
        _this.cancel = c
      }),
      headers: {
        Authorization: sessionStorage.getItem('token')
      }
    }).then(function (resp) {
      if (resp.data.code === 200) {
        resp.data.data.pag[0].devId = resp.data.data.pag[0].devId.toString()// 转成string防止丢失精度
        _this.icon = _this.$cautionIconFun.setIconAndPopupHtmlLLMap(_this, resp.data.data.pag[0])
        // console.log("123123123213123status",_this.icon)

        resp.data.data.pag[0].coordinate = resp.data.data.pag[0].lLonWgs84.toFixed(6) + ',' + resp.data.data.pag[0].lLatWgs84.toFixed(6)
        _this.watchDeviceList = resp.data.data.pag
        _this.poineList.push(resp.data.data.pag[0])
        _this.markerCluster.eachLayer(function (layer) {
          if (layer.options.id === resp.data.data.pag[0].devId) {
            _this.markerCluster.removeLayer(layer)
          }
        })
        _this.markerCluster.addLayer(_this.$L.marker([resp.data.data.pag[0].lLatWgs84, resp.data.data.pag[0].lLonWgs84], {
          id: resp.data.data.pag[0].devId,
          icon: _this.icon,
          rotationAngle: resp.data.data.pag[0].lDirection,
          rotationOrigin: 'center center'
        }))
        if (_this.poineList.length > 1) {
          _this.$L.marker([_this.poineList[_this.poineList.length - 2].lLatWgs84, _this.poineList[_this.poineList.length - 2].lLonWgs84], {
            icon: _this.$L.icon({
              iconUrl: require('../../assets/images/linePoint.png'),
              iconSize: [14, 14]
            }),
            rotationAngle: _this.poineList[_this.poineList.length - 2].lDirection,
            rotationOrigin: 'center center'
          }).addTo(_this.map)
          // console.log("fitBoundsList", _this.poineList[_this.poineList.length - 2].lDirection)
          let routeLineLayer = null
          // console.log("fitBoundsList",_this.poineList)
          _this.path = []
          _this.path.push([_this.poineList[_this.poineList.length - 2].lLatWgs84, _this.poineList[_this.poineList.length - 2].lLonWgs84])
          _this.path.push([_this.poineList[_this.poineList.length - 1].lLatWgs84, _this.poineList[_this.poineList.length - 1].lLonWgs84])
          routeLineLayer = _this.$L.polyline(_this.path, {
            color: '#2f7aec',
            weight: 6
          })
          _this.leafletGroup.addLayer(routeLineLayer).addTo(_this.map)
        }
        if (_this.poineList.length === 1) {
          _this.map.fitBounds([{ lat: _this.poineList[_this.poineList.length - 1].lLatWgs84, lng: _this.poineList[_this.poineList.length - 1].lLonWgs84 }])
        }
        let electric = null
        if (resp.data.data.pag[0].lElectricQuantity * 1 > 90) {
          electric = require('../../assets/images/电池/100.png')
        } else if (resp.data.data.pag[0].lElectricQuantity * 1 > 50) {
          electric = require('../../assets/images/电池/50-90.png')
        } else if (resp.data.data.pag[0].lElectricQuantity * 1 > 20) {
          electric = require('../../assets/images/电池/20-50.png')
        } else {
          electric = require('../../assets/images/电池/0-20.png')
        }
        if (resp.data.data.pag[0].lElectricQuantity == null) {
          resp.data.data.pag[0].lElectricQuantity = '未知'
          electric = require('../../assets/images/电池/0.png')
        }
        if (resp.data.data.pag[0].signalIntensity == null) {
          resp.data.data.pag[0].signalIntensity = '未知'
        }
        var status = ''
        if (resp.data.data.pag[0].status === 3) {
          status = (resp.data.data.pag[0].lOpenAcc === 1 ? '点火' : '熄火') + ' ' + _this.lImmediatelyStatusDic(resp.data.data.pag[0].status)
          if (resp.data.data.pag[0].offLineTimeStr !== null && resp.data.data.pag[0].offLineTimeStr !== '') {
            status = status + ' ' + (resp.data.data.pag[0].offLineTimeStr)
          }
        } else {
          status = (resp.data.data.pag[0].lOpenAcc === 1 ? '点火' : '熄火') + ' ' + _this.lImmediatelyStatusDic(resp.data.data.pag[0].status) + ' ' + (resp.data.data.pag[0].lSpeed / 10) + 'Km/h'
        }

        var html = '<div style="width: 300px; height: 160px; background-color: #FFFFFF; ">' +
          '<div style="width: 100%; height: 35px; border-radius: 5px 5px 0 0; border-bottom: #f1f1f1 solid 1px">' +
          '<table>' +
          '<tr>' +
          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/电备份 3@2x.png') + '" style="height: 12px; width: 12px">15</td>' +
          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/编组 6@2x.png') + '" style="height: 12px; width: 12px">5</td>' +
          '<td style="padding: 0">' +
          '<div style="float: left; margin-left: 5px"><img src="' + electric + '" style="height: 20px; width: 20px; margin-top: 5px"></div><div style="float: left; line-height: 30px; font-size: 12px; margin-left: 5px">' + resp.data.data.pag[0].lElectricQuantity + '%</div></td>' +
          '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/信号备份 2@2x.png') + '" style="height: 12px; width: 12px"> ' + resp.data.data.pag[0].signalIntensity + '</td>' +
          // '<td style="padding: 6px 8px; font-size: 12px; line-height: 30px"><img src="' + require('../../assets/images/SIM 流量卡.png') + '" style="height: 12px; width: 12px"></td>' +
          '</tr>' +
          '</table>' +
          '</div>' +
          '<div style="width: 70%; float: right; padding: 10px 20px 0 20px">' +
          '<table>' +
          '<tr>' +
          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备名称:</span></td>' +
          '<td><span style="font-size: 12px">' + resp.data.data.pag[0].devName + '</td>' +
          '</tr>' +
          '<tr>' +
          '<tr>' +
          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备状态:</span></td>' +
          '<td><span style="font-size: 12px">' + status + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">设备编号:</span></td>' +
          '<td><span style="font-size: 12px">' + resp.data.data.pag[0].devImei + '</td>' +
          '</tr>' +
          '<tr>' +
          '<td style="width: 55px"><span style="font-weight: bold; font-size: 12px">定位时间:</span></td>' +
          '<td><span style="font-size: 12px">' + resp.data.data.pag[0].lRecordTime + '</td>' +
          '</tr>' +
          '</table>' +
          '</div>' +
          '</div>'
        // _this.markerCluster.bindPopup()
        if (_this.pop === undefined) {
          _this.pop = _this.$L.popup()
        }
        _this.pop.setLatLng({ lat: resp.data.data.pag[0].lLatWgs84, lng: resp.data.data.pag[0].lLonWgs84 })
        _this.pop.setContent(html)
        _this.pop.openOn(_this.map)
        // console.log("32312321321321")
      }
    })
  }
}
export default leafLetCtl



// WEBPACK FOOTER //
// ./src/javascript/function/trackingFunctionLeafle.js